import { STYLE_OPTIONS } from 'src/constants';
import tabEditStyle from 'src/components/View/AccountView/tabEdit.style';
import modalDialogFormStyle from 'src/components/View/ModalDialogForm/modalDialogForm.style';

const color = '#5850EC';
const fontFamily = STYLE_OPTIONS.FONT_FAMILY;

const modalFormsStyle = (theme) => ({
  ...tabEditStyle(theme),
  ...modalDialogFormStyle(theme),

  applyButton: {
    ...STYLE_OPTIONS.BUTTON_PRIMARY_REVERSED,
    width: '100%',
    boxShadow: 'none !important',
    border: `1px solid ${STYLE_OPTIONS.COLOR_BLUE}`,
    height: 56,
  },

  optionValues: {
    color,
    fontFamily,
    fontSize: '14px',
  },

});

export default modalFormsStyle;
